import React from 'react';

const AnnouncementSection = () => {
  const announcements = [
    // { text: 'D.A. Jan25 form available', link: '/daArrearsForm', isNew: true },
    { text: 'Senior College Placement', link: '/srPlacementForm', isNew: false },
    { text: 'New Appointment High School', link: '/hsNewAppointment', isNew: true },
    { text: 'How to fill D.A. Arrears Form?', link: 'https://youtu.be/7Cu-JBy_Sr4', isNew: false },
    { text: 'View Latest GR here!', link: '/GR', isNew: true },
    { text: 'What is Fitment Factor?', link: 'https://www.youtube.com/shorts/cwmYFxmBlIc', isNew: false },
  ];

  return (
    <div 
      className="w-full md:w-1/3 mt-0 md:mt-0 md:mr-24 p-0 overflow-hidden h-96 rounded-lg"
      style={{
        border: '3px solid #4CAF50',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        backgroundColor: '#f8f8f8',
        fontFamily: "'Poppins', sans-serif"
      }}
    >
      {/* Header with Green-Red Theme */}
      <div 
        className="text-white text-2xl font-bold py-4 px-6 flex items-center"
        style={{ 
          background: '#4CAF50',
          borderBottom: '3px solid #388E3C',
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
          fontFamily: "'Poppins', sans-serif"
        }}
      >
        <div className="bg-white rounded-full p-2 mr-3">
          <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" 
              fill="#F44336"
            />
          </svg>
        </div>
        IMPORTANT UPDATES
      </div>

      {/* Content Area */}
      <div 
        className="p-4 h-64 overflow-y-auto bg-white"
        style={{
          scrollbarWidth: 'thin',
          fontFamily: "'Poppins', sans-serif"
        }}
      >
        <ul className="space-y-4" style={{ listStyleType: 'none', paddingLeft: '0' }}>
          {announcements.map((item, index) => (
            <li
              key={index}
              className="py-2 px-1 hover:bg-red-50 rounded transition-colors duration-200"
              style={{
                borderBottom: '2px dotted #E0E0E0',
                position: 'relative',
                fontFamily: "'Poppins', sans-serif"
              }}
            >
              <a 
                href={item.link} 
                className="flex items-start"
                target={item.link.startsWith('http') ? '_blank' : '_self'}
                rel="noopener noreferrer"
                style={{
                  textDecoration: 'none',
                  color: '#333',
                  fontSize: '1.25rem',
                  fontWeight: '600',
                  fontFamily: "'Poppins', sans-serif"
                }}
              >
                {/* Red bullet point */}
                <div 
                  className="mr-3 mt-1 flex-shrink-0"
                  style={{
                    width: '24px',
                    height: '24px',
                    backgroundColor: '#FFEBEE',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid #F44336'
                  }}
                >
                  <div 
                    style={{
                      width: '12px',
                      height: '12px',
                      backgroundColor: '#F44336',
                      borderRadius: '50%'
                    }}
                  ></div>
                </div>

                {/* Announcement text */}
                <div style={{ flex: 1 }}>
                  <span 
                    className="hover:text-green-700"
                    style={{
                      transition: 'color 0.2s',
                      display: 'inline-block',
                      fontFamily: "'Poppins', sans-serif"
                    }}
                  >
                    {item.text}
                    {item.link.startsWith('http') && (
                      <svg 
                        className="inline ml-2"
                        width="18" 
                        height="18" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ verticalAlign: 'middle' }}
                      >
                        <path 
                          d="M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V11H19V6.413L11.207 14.207L9.793 12.793L17.585 5H13V3H21Z" 
                          fill="#4CAF50"
                        />
                      </svg>
                    )}
                  </span>
                </div>

                {/* Animated "NEW" image */}
                {item.isNew && (
                  <div 
                    className="animate-pulse"
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)'
                    }}
                  >
                    <img
                      src="/Images/New.png" 
                      alt="New"
                      style={{
                        height: '36px',
                        filter: 'drop-shadow(2px 2px 2px rgba(0,0,0,0.3))',
                        animation: 'pulse 1.5s infinite'
                      }}
                    />
                  </div>
                )}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Footer with Red Accent */}
      <div 
        className="text-center py-2 text-sm font-medium flex justify-center items-center"
        style={{
          backgroundColor: '#E8F5E9',
          color: '#2E7D32',
          borderTop: '2px solid #C8E6C9',
          fontFamily: "'Poppins', sans-serif"
        }}
      >
        <svg 
          className="mr-2"
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4Z" 
            fill="#F44336"
          />
          <path 
            d="M11 7H13V9H11V7ZM11 11H13V17H11V11Z" 
            fill="#F44336"
          />
        </svg>
        Last Updated: 27 Dec 2025
      </div>

      {/* Animation Styles */}
      <style jsx global>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
        
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
        .animate-pulse {
          animation: pulse 1.5s infinite;
        }
      `}</style>
    </div>
  );
};

export default AnnouncementSection;